<script>
import CommonPhrasesModal from '@/components/CommonPhrasesModal.vue';

export default {
  name: 'CarbonCopyModal',
  components: { CommonPhrasesModal },
  data() {
    this.initForm = {
      employeeIds: [],
      formFlowId: null,
      formId: null,
      remark: null
    };
    return {
      modal: false,
      remark: null,
      sbLoading: false,
      employeeSelectLoading: false,
      employees: [],
      rules: {
        employeeIds: {
          required: true,
          message: this.$t('global.text14')
        }
      },
      formValidate: _.cloneDeep(this.initForm)
    };
  },
  methods: {
    cleanReviewText(text) {
      return text
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\&nbsp;/g, ' ')
        .replace(/<.*?>/g, '');
    },
    onChangePhrases(phrases) {
      const review = `${this.review || ''}${phrases}`;
      this.formData.review = review;
      this.review = this.cleanReviewText(review);
    },
    onChange(e) {
      const rawValue = e.target.value;
      this.formData.review = rawValue
        .replace(/\r{0,}\n/g, '<br/>')
        .replace(/\s/g, '&nbsp;');
      this.review = this.cleanReviewText(rawValue);
    },
    async openModal(e) {
      this.modal = true;
      this.remark = null;
      try {
        const { data } = await this.$http(
          'get',
          `/mobile/forms/${e.id}`,
          {},
          true
        );

        this.formValidate.formId = e.id;
        const { currentFormFlow } = data;
        if (!currentFormFlow) return;
        await this.initEmployees();
        this.formValidate.formFlowId = currentFormFlow.id;
        this.$refs['formValidate'].resetFields();
      } catch (e) {}
    },

    remoteMethod: _.debounce(function (query) {
      this.initEmployees(query);
    }, 300),

    async initEmployees(query) {
      try {
        this.employeeSelectLoading = true;
        const result = await this.$http(
          'get',
          'mobile/employees/select_list',
          {
            search: query
          },
          true
        );
        this.employees = result.data.content;
      } finally {
        this.employeeSelectLoading = false;
      }
    },

    // 关闭弹窗
    onCancel() {
      this.modal = false;
      this.formValidate = _.cloneDeep(this.initForm);
    },
    onSubmit() {
      this.$refs['formValidate'].validate(async (v) => {
        if (v) {
          try {
            const form = _.cloneDeep(this.formValidate);
            this.sbLoading = true;
            await this.$http(
              'post',
              `mobile/forms/${form.formId}/notice`,
              form,
              true
            );
            this.$Message.success(this.$t(`message.cc`));
            this.sbLoading = false;
            this.onCancel();
            this.$emit('onUpdate');
          } catch (e) {
            this.sbLoading = false;
          }
        }
      });
    }
  }
};
</script>

<template>
  <Modal
    v-model="modal"
    :mask-closable="false"
    :title="$t('btn.cc')"
    width="520"
    @on-cancel="onCancel"
  >
    <Form
      v-if="modal"
      ref="formValidate"
      :rules="rules"
      :model="formValidate"
      :label-width="110"
      label-position="right"
    >
      <FormItem :label="$t('apply.NOTIFIER')" prop="employeeIds">
        <Select
          v-model="formValidate.employeeIds"
          filterable
          clearable
          :not-found-text="$t('i.table.noDataText')"
          @on-clear="initEmployees"
          remote
          multiple
          :remote-method="remoteMethod"
          :placeholder="$t('global.search_query')"
          :loading="employeeSelectLoading"
          class="i-w-300"
        >
          <Option
            v-for="item in employees"
            :value="item.id"
            :label="item.fullName"
            :key="item.id"
          >
            {{ item.fullName }}
          </Option>
        </Select>
      </FormItem>
      <FormItem :label="$t('global.text12')" prop="remark">
        <Input
          type="textarea"
          class="i-w-300"
          :maxlength="200"
          show-word-limit
          :value="remark"
          @on-change="onChange"
          :placeholder="$t('global.text13')"
        />
        <CommonPhrasesModal @onChange="onChangePhrases" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button @click="onCancel">
        {{ $t('btn.cancel') }}
      </Button>
      <Button type="primary" :loading="sbLoading" @click="onSubmit">
        {{ $t('btn.done') }}
      </Button>
    </div>
  </Modal>
</template>
